import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
// import Button from "../../../../components/common/Button/Button";
import images from "../../../../images";

const TakeResultStep3 = ({ handleAction, result, handleRecommendation }) => {
  const { t } = useTranslation();

  // Memoize key_insights to avoid unnecessary re-computation
  const keyInsights = useMemo(() => {
    return Array.isArray(result?.data?.quest_result?.key_insights)
      ? result.data.quest_result.key_insights
      : [];
  }, [result]);

  // Handle missing or invalid data
  if (!result?.data?.quest_result) {
    return (
      <section className="flex flex-col items-center w-full max-w-[396px] mx-auto">
        <div className="text-center text-red-500 py-5">
          {t("error.noResultData")}
        </div>
      </section>
    );
  }

  return (
    <section className="flex flex-col items-center w-full  mx-auto gap-2">
      {keyInsights.length > 0 ? (
        keyInsights.map((insight, index) => (
          <article
            className="p-4 bg-yellow-50 rounded-xl text-zinc-800 w-full"
            key={index}
          >
            <div className="w-full mt-3 rounded-xl p-4 cursor-pointer">
              <div>
                <h2 className="text-base font-semibold">
                  {t("base.Insight")} {index + 1}
                </h2>
                <p className="px-3 py-2 mt-2 text-xs font-medium bg-white rounded-lg">
                  {insight.topic || t("base.noInsightTopic")}
                </p>
              </div>
              <div className="mt-3">
                <h2 className="text-base font-semibold">
                  {t("base.recommendation")}
                </h2>
                {Array.isArray(insight.recommendation) &&
                insight.recommendation.length > 0 ? (
                  insight.recommendation.map((rec, recIndex) => (
                    <div key={recIndex} className="mt-2">
                      <p className="px-3 py-2 text-xs font-medium bg-white rounded-lg">
                        {rec.focus_area ||
                          t("quest.questResult.noRecommendation")}
                      </p>
                    </div>
                  ))
                ) : (
                  <p className="px-3 py-2 mt-2 text-xs font-medium bg-white rounded-lg">
                    {t("quest.questResult.noRecommendation")}
                  </p>
                )}
              </div>
            </div>
            {/* <Button
              className="w-full px-3 py-2 mt-4 text-sm bg-white rounded-xl border border-indigo-600"
              icon={images.DoubleArrowIcon}
              text="NPS"
              aria-label={t("base.npsButton")}
            />
            <Button
              className="w-full px-3 py-2 mt-2 text-sm bg-white rounded-xl border border-indigo-600"
              icon={images.DoubleArrowIcon}
              text="CLTV"
              aria-label={t("base.cltvButton")}
            /> */}
            <button
              onClick={() => handleRecommendation(insight)}
              className="flex items-center justify-center w-full px-6 py-3 mt-3 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-400 rounded-xl  hover:opacity-90"
              aria-label={t("base.action")}
            >
              <img
                src={images.ZapIcon}
                alt={t("quest.questResult.action")}
                className="w-4 h-4 mr-2"
              />
              <span>{t("base.action")}</span>
            </button>
          </article>
        ))
      ) : (
        <div className="text-center text-gray-500 py-2">
          {t("quest.questResult.noInsightsAvailable")}
        </div>
      )}
    </section>
  );
};

export default TakeResultStep3;
